import styles from './SocialLinksAd.module.scss';

import { links } from 'settings';
import classNames from 'classnames';

export const SocialLinksAd = () => {
	return (
		<a href={links.social.telegram} className={classNames(styles.container, 'flex-container-horizontal')}>
			<span className="flex-size-fill">RUSETFS в соц. сетях</span>
			<span className="flex-size-auto">
				TG
			</span>
		</a>
	);
}